<template>
    <span :class="classes">
        <slot></slot>
    </span>
</template>
<script>
    import theme from './text.scss';

    export default {
        name: 'text',
        props: {
            nowrap: Boolean,

            // weight
            bold: Boolean,
            medium: Boolean,
            light: Boolean,
            secondary: Boolean,

            // colors
            danger: Boolean,
            success: Boolean,
            white: Boolean,

            type: {
                type: String, // caption, subheadling, title, headline,
                validator(type) {
                    return ['caption', 'subheadling', 'title', 'headline'].includes(type);
                }
            },

            // align
            middle: Boolean,
            top: Boolean,

            theme: {
                type: Object,
                default() {
                    return theme;
                }
            }
        },
        computed: {
            classes() {
                return {
                    [this.theme.text]: true,
                    [this.theme['is-' + this.type]]: this.type,
                    [this.theme.isNowrap]: this.nowrap,
                    [this.theme.secondary]: this.secondary,
                    [this.theme.isBold]: this.bold,
                    [this.theme.isMedium]: this.medium,
                    [this.theme.isLight]: this.light,
                    [this.theme.isDanger]: this.danger,
                    [this.theme.isSuccess]: this.success,
                    [this.theme.isWhite]: this.white,
                    [this.theme.isMiddle]: this.middle,
                    [this.theme.isTop]: this.top,
                };
            }
        },
    }
</script>


// WEBPACK FOOTER //
// Text.vue?75495a16